'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true
})

var _extends =
  Object.assign ||
  function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i]
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key]
        }
      }
    }
    return target
  }

var _templateObject = _taggedTemplateLiteral(
  ['\n  display: flex;\n  ', ' ', ' ', ' ', ' ', ' ', ';\n'],
  ['\n  display: flex;\n  ', ' ', ' ', ' ', ' ', ' ', ';\n']
)

var _styledSystem = require('styled-system')

var _Box = require('./Box')

var _Box2 = _interopRequireDefault(_Box)

var _propTypes = require('prop-types')

var _propTypes2 = _interopRequireDefault(_propTypes)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(
    Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })
  )
}

var wrap = function wrap(props) {
  return props.wrap ? { flexWrap: 'wrap' } : null
}

var Flex = _Box2.default.extend(
  _templateObject,
  _styledSystem.alignSelf,
  _styledSystem.alignItems,
  _styledSystem.justifyContent,
  wrap,
  _styledSystem.flexDirection,
  _styledSystem.flex
)

Flex.propTypes = _extends(
  {
    wrap: _propTypes2.default.bool
  },
  _styledSystem.propTypes.alignSelf,
  _styledSystem.propTypes.alignItems,
  _styledSystem.propTypes.justifyContent,
  _styledSystem.propTypes.flexDirection,
  _styledSystem.propTypes.flex
)

Flex.displayName = 'Flex'

exports.default = Flex



//////////////////
// WEBPACK FOOTER
// ./~/@hackclub/design-system/dist/Flex.js
// module id = 62
// module chunks = 168707334958949